import { render, staticRenderFns } from "./playthrough.vue?vue&type=template&id=5932e059&scoped=true"
import script from "./playthrough.vue?vue&type=script&lang=js"
export * from "./playthrough.vue?vue&type=script&lang=js"
import style0 from "./playthrough.vue?vue&type=style&index=0&id=5932e059&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932e059",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bonuses/playthrough.vue
// module id = ip2m
// module chunks = 0